





















































































import { quillEditor } from 'vue-quill-editor'
import { Component, Prop, Vue } from "vue-property-decorator";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { safeHtml } from '@/views/chantiers/safe-html'

@Component({
  components: {
    quillEditor
  },
  name: "ressifnet-quill-editor",
})
export default class RessifnetQuillEditor extends Vue {
  @Prop({ default: false, required: false }) enableImage!: boolean;
  @Prop({ default: false, required: false }) enableVideo!: boolean;
  @Prop({ default: false, required: false }) enableLink!: boolean;
  random  = this.getRandom()

  snowOption: any = {
    theme: 'snow',
    placeholder: 'Saississez votre texte',
    modules: {
      toolbar: `#${this.random}`
    }
  }

  // Dernière position connue du curseur : repli quand l'éditeur a perdu le focus
  // (ex. après l'aller-retour de transcription), pour insérer au bon endroit.
  lastRange: any = null;

  mounted() {
    const ed: any = this.$refs.quill;
    const quill = ed ? ed.quill : null;
    if (quill) {
      quill.on('selection-change', (range: any) => { if (range) this.lastRange = range; });
    }
  }

  getRandom() {
    let one = Math.random()*10000
    let two = Math.random()*10000
    let three = Math.random()*10000

    return "toolbar-" + Math.floor(one + three * two);
  }

  // Insère du texte à la position du curseur (ou en fin si l'éditeur n'a pas le focus).
  // insertText déclenche text-change → emit('input') de quill-editor → met à jour le v-model.
  insertTextAtCursor(text: string): void {
    const ed: any = this.$refs.quill;
    const quill = ed ? ed.quill : null;
    if (!quill) return;
    const len = quill.getLength();
    const range = quill.getSelection() || this.lastRange;
    // getLength() inclut le \n final → insérer avant lui ; on borne aussi un lastRange périmé (texte supprimé entre-temps).
    let index = range ? range.index : Math.max(0, len - 1);
    index = Math.min(Math.max(index, 0), Math.max(0, len - 1));
    quill.insertText(index, text, 'user');
    const newIndex = index + text.length;
    quill.setSelection(newIndex, 0);
    this.lastRange = { index: newIndex, length: 0 };
  }

  // Texte brut courant de l'éditeur (pour l'envoyer à la mise en forme IA).
  getPlainText(): string {
    const ed: any = this.$refs.quill;
    return ed && ed.quill ? ed.quill.getText() : '';
  }

  // Remplace tout le contenu par du HTML (sanitizé). Annulable via Ctrl+Z ; déclenche text-change → v-model.
  setHtml(html: string): void {
    const ed: any = this.$refs.quill;
    const quill = ed ? ed.quill : null;
    if (!quill) return;
    const clean = safeHtml(html);
    if (!clean) return; // garde-fou : ne JAMAIS vider la note avec un HTML vide
    const delta = quill.clipboard.convert(clean);
    quill.setContents(delta, 'user');
  }
}
